<div
  *ngFor="
    let group of servicesListGrouped;
    let g = index;
    trackBy: trackByGroup
  "
  class="booking-card"
>
  <div class="table-service-header">
    <h3>{{ group.careServiceName }}</h3>
  </div>
  <div class="table-container">
    <div
      *ngFor="
        let service of group.services;
        let i = index;
        trackBy: trackByService
      "
      class="table_row test-booking-service-row-{{ i }}"
    >
      <div class="table_row__content">
        <div class="service">
          <div
            (click)="onClickService(service, group.careServiceId)"
            class="name"
          >
            {{ service.name }}
          </div>
          <div [ngClass]="getItemDetailsCssClass(service)" class="details">
            <app-price-info
              [activityLength]="service.activityLength"
              [isFromPrice]="service.isFromPrice"
              [priceDescription]="service.priceDescription"
              [price]="service.price"
            ></app-price-info>
            <div
              *ngIf="service.seoInformation && service.seoInformation !== ''"
              class="delimiter desktop-only"
            ></div>
            <div
              (click)="openTreatmentDetailsModal(service, group.careServiceId)"
              *ngIf="service.seoInformation && service.seoInformation !== ''"
              class="treatment-details-inline"
            >
              Mer om behandlingen
            </div>
          </div>
          <div
            (click)="openTreatmentDetailsModal(service, group.careServiceId)"
            *ngIf="service.seoInformation && service.seoInformation !== ''"
            class="treatment-details"
          >
            Mer om behandlingen
          </div>
        </div>
        <div class="service-action">
          <app-ui-button
            (click)="onClickService(service, group.careServiceId)"
            [compressed]="true"
            [expanded]="'block'"
            color="green"
          >
            Välj
          </app-ui-button>
        </div>
      </div>
    </div>
  </div>
</div>
